@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.multi-package {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 95%;
  color: var(--grey-600);

  .icon {
    width: 24px;
    padding: 6px @space-4 @space-4 @space-8;
  }

  &:hover,
  &:focus {
    .icon {
      fill: @fulfillment-planner--package--hover--fill-color;
    }
  }
}
